import Service from '@ember/service';
import ENV from 'lumen/config/environment';

// All Spider iframes in lumen use an id prefixed with "spider-" (see
// app/templates/**/spider-dashboard.gts and friends). Only one is mounted
// at a time, so the first match is the active one.
const SPIDER_IFRAME_SELECTOR = 'iframe[id^="spider-"]';

export default class SpiderService extends Service {
  // Tell the active Spider iframe to update its date range in-place,
  // skipping the full reload that a query-param change would otherwise require.
  // No-op when no Spider iframe is mounted — Spider's first navigation reads
  // dates from the URL anyway.
  updateDateRange(
    startDate: string,
    endDate: string,
    pickupFrom: string,
  ): void {
    const iframe = document.querySelector<HTMLIFrameElement>(
      SPIDER_IFRAME_SELECTOR,
    );

    if (!iframe?.contentWindow) {
      return;
    }

    iframe.contentWindow.postMessage(
      {
        event: 'lumen-update-date-range',
        startDate,
        endDate,
        pickupFrom,
      },
      new URL(ENV.spiderIframeURL).origin,
    );
  }
}

declare module '@ember/service' {
  interface Registry {
    spider: SpiderService;
  }
}
